import { render } from "./SendIcon.vue?vue&type=template&id=89b4a47a"
const script = {}
script.render = render

export default script